import { apiClient } from '@/api/client';
import { Filter } from '@/api/models';
import { useEntityMutations } from '@/hooks/useEntityMutations';
import { queryKeys } from '@/lib/queryKeys';

export interface FilterFormData {
  name: string;
  enabled: boolean;
  isMandatory: boolean;
}

export const useFilterMutations = () => {
  return useEntityMutations<FilterFormData, Filter>({
    entityName: 'Filter',
    basePath: '/filters',
    queryKeys: [queryKeys.ADMIN_FILTERS],
    getId: filter => filter.id!,
    getDeleteConfirmMessage: filter =>
      `Are you sure you want to delete "${filter.name}"?`,
    createFn: async data => {
      const response = await apiClient.POST('/admin/filters', {
        body: { name: data.name, isMandatory: data.isMandatory },
      });
      if (response.error) throw new Error('Failed to create filter');
      return response.data;
    },
    updateFn: async data => {
      const response = await apiClient.PUT('/admin/filters/{id}', {
        params: { path: { id: data.id } },
        body: {
          name: data.name,
          enabled: data.enabled,
          isMandatory: data.isMandatory,
        },
      });
      if (response.error) throw new Error('Failed to update filter');
      return response.data;
    },
    deleteFn: async id => {
      const response = await apiClient.DELETE('/admin/filters/{id}', {
        params: { path: { id } },
      });
      if (response.error) throw new Error('Failed to delete filter');
    },
  });
};
